const {
	fillWithDomElements,
	waitForElmToLoad,
	trackGtm4,
} = require('util/functions.js');
const {
	outClickSubscribe,
	outClickUnSubscribe,
} = require('util/outClickSubscriber');

const CLASS_MODAL = 'modal-controller';
const CLASS_MODAL_TRIGGER = 'modal-trigger';
const CLASS_MODAL_IFRAME = 'ir-email-modal--iframe';
const CLASS_CLOSE = 'pop-up-widget--close';
const CLASS_CONTENT = 'pop-up-widget--content';
const CLASS_SLOT = 'pop-up-widget--slot';
const CLASS_CTA = 'investor-cta-newsletter';
const CLASS_POPUP_WIDGET = 'pop-up-widget';

const CLASS_HIDDEN = 'hidden';

const elementClasses = {
	modal: CLASS_MODAL,
	modalTrigger: CLASS_MODAL_TRIGGER,
	iframe: CLASS_MODAL_IFRAME,
	closeBtn: CLASS_CLOSE,
	content: CLASS_CONTENT,
	slot: CLASS_SLOT,
	cta: CLASS_CTA,
	popupWidget: CLASS_POPUP_WIDGET,
};

module.exports = {
	async init() {
		fillWithDomElements(this, elementClasses);
		this.initStyle();
		this.clickedOutside = false;
		await this.initGigyaNewsletter();
		this.closeBtn.setAttribute('aria-label', document.body.dataset.closeLabel);
		this.initEvents();
	},
	initStyle() {
		if (
			this.root.dataset.bgColor &&
			this.root.dataset.bgColor.length &&
			this.cta
		) {
			this.cta.style.backgroundColor = this.root.dataset.bgColor;
			this.cta.style.borderColor = this.root.dataset.bgColor;
		}
	},
	initEvents() {
		const backGrounds = document.getElementsByClassName(
			'pop-up-widget--background',
		);

		this.buttons = document.getElementsByClassName(
			'investor-cta--newsletter-button',
		);
		this.modals = document.querySelector('.pop-up-widget');

		if (this.buttons.length) {
			for (let i = 0; i < this.buttons.length; i++) {
				if (!this.buttons[i].getAttribute('href')?.length) {
					this.buttons[i].addEventListener('click', e => {
						this.modals.classList.remove('hidden');
						trackGtm4({
							event: 'GA4_event_c_newsletter_form_start',
							widget_name: 'V3-Popup-Newsletter',
							newsletter_type: 'corporate-newsletter',
						});
						e.stopImmediatePropagation();
					});
				}
			}

			for (let i = 0; i < backGrounds.length; i++) {
				backGrounds[i].addEventListener('click', () => {
					for (const modal of this.modals) modal.classList.add('hidden');
				});
			}
		} else {
			window.addEventListener('scroll', this.detectScroll.bind(this));
		}

		this.closeBtn.addEventListener('click', this.btnClosePopUp.bind(this));
		document.addEventListener('keydown', e => {
			if (e.key === 'Escape') {
				for (let i = 0; i < this.modals.length; i++) {
					this.toogleClass(this.modals[i]);
				}
			}
		});
	},
	detectScroll() {
		if (!this.clickedOutside) {
			const scrolled = document.documentElement.scrollTop;
			const totalScroll =
				document.documentElement.scrollHeight -
				document.documentElement.clientHeight;
			const halfPageScrolled = scrolled > totalScroll / 2 ? true : false;

			if (halfPageScrolled) this.checkLocalStorage();
		}
	},
	checkLocalStorage() {
		const subscribed = JSON.parse(localStorage.getItem('userSubscribed'));
		const currentDate = new Date();
		if (!subscribed) {
			this.togglePopUp(false);
		} else if (currentDate.toISOString().split('T')[0] > subscribed?.expiry) {
			localStorage.removeItem('userSubscribed');
			this.togglePopUp(false);
		} else if (!subscribed?.expiry) {
			return;
		}
	},
	btnClosePopUp() {
		const subscribed = JSON.parse(localStorage.getItem('userSubscribed'));
		if (!subscribed) {
			const currentDate = new Date();
			const plusMonthDate = currentDate.setMonth(currentDate.getMonth() + 1);
			const newDate = new Date(plusMonthDate).toISOString().split('T')[0];
			const subscribedProperty = {
				value: true,
				expiry: newDate,
			};
			localStorage.setItem(
				'userSubscribed',
				JSON.stringify(subscribedProperty),
			);
		}

		this.togglePopUp(true);
	},
	togglePopUp(hide) {
		if (!hide) outClickSubscribe(this.content, this.toogleClass.bind(this));
		this.popupWidget.classList.toggle(CLASS_HIDDEN, hide);
		this.toggleScroll(hide);
	},
	toggleScroll(hide) {
		if (!hide) {
			if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
				this.scrollPositon = document.documentElement.scrollTop;
				document.documentElement.style.height = '100vh';
				setTimeout(() => {
					document.body.classList.add('no-scroll-ios');
				}, 500);
			} else {
				document.body.classList.add('no-scroll');
			}
		} else {
			if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
				document.body.classList.remove('no-scroll-ios');
				document.documentElement.style.height = null;
				window.scroll({
					top: this.scrollPositon,
					left: 0,
					behavior: 'smooth',
				});
			} else {
				document.body.classList.remove('no-scroll');
			}
		}
	},
	toogleClass({ target }) {
		const oneTrust = document.getElementById('onetrust-consent-sdk');
		if (target !== oneTrust && !oneTrust?.contains(target)) {
			this.clickedOutside = true;
			outClickUnSubscribe(this.content);
			this.popupWidget.classList.add(CLASS_HIDDEN);
			this.toggleScroll(true);
		}
	},
	async initGigyaNewsletter() {
		if (window.gigya) {
			const screenSetId = this.root.dataset.screenSet;
			const lang = this.root.dataset.lang;
			window.gigya.accounts.showScreenSet({
				screenSet: screenSetId,
				containerID: 'gigya-form-newsletter',
				deviceType: 'auto',
				lang: lang,
			});
			const gigyaSubmitBtn = await waitForElmToLoad(
				'.pop-up-widget  .gigya-input-submit',
			);
			gigyaSubmitBtn.addEventListener('click', this.onSubmit.bind(this));
		}
	},
	onSubmit() {
		const observer = new MutationObserver(function (mutations_list) {
			mutations_list.forEach(function (mutation) {
				mutation.removedNodes.forEach(function (removed_node) {
					if (!document.querySelector('.pop-up-widget--gigya form')) {
						const subscribedProperty = {
							value: true,
							expiry: false,
						};
						localStorage.setItem(
							'userSubscribed',
							JSON.stringify(subscribedProperty),
						);
						observer.disconnect();
					}
				});
			});
		});
		observer.observe(document.querySelector('.pop-up-widget--gigya'), {
			subtree: false,
			childList: true,
		});
	},
};
